import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useBookLiveCorrectionMutation } from "@/data/exercises.ts";
import { useMe } from "@/data/user.ts";
import routes from "@/config/routes.ts";
import { Button } from "@/components/ui/Button.tsx";
import CalendarIllustration from "@/components/ui/CalendarIllustration.tsx";

interface ConfirmModalState {
  date: string;
  hour: string;
  tutor: string;
}

function MobileConfirmLiveCorrection() {
  const location = useLocation();
  const { date: stateDate, hour, tutor } = location.state as ConfirmModalState;
  const date = dayjs(stateDate);

  const { me } = useMe();
  const user = me?.item.user;
  const navigate = useNavigate();

  const { mutate, isLoading } = useBookLiveCorrectionMutation();

  const handleConfirm = () => {
    if (!user) return navigate(routes.login);

    mutate({
      user_id: user.id,
      tutor_token: tutor,
      user_token: user.token,
      data: date.format("YYYY-MM-DD"),
      ora: hour,
      ora_fine: dayjs(date.format("YYYY-MM-DD") + " " + hour)
        .add(30, "minutes")
        .format("HH:mm"),
      type: "Mock test",
    });
  };

  return (
    <div className={"w-full h-full max-w-md mx-auto my-10 space-y-10"}>
      <div className={"space-y-1"}>
        <p className={"text-light text-2xl font-semibold"}>
          Writing correction
        </p>
        <p className={"text-light text-xl"}>
          Choose date & time of the live correction
        </p>
      </div>

      <div className=" flex flex-col items-center justify-between h-full w-full my-4">
        <CalendarIllustration
          className="w-[206px] h-[215px] bg-brand-deep border-brand-deep border-solid border-2 rounded-lg"
          header={date.format("ddd")}
          day={date.format("DD")}
          month={date.format("MMM")}
        />
        <div className="flex flex-col gap-8 h-fit my-auto items-center">
          <div className={"space-y-0.5 text-center my-4"}>
            <h5 className={"text-light text-lg"}>Time</h5>
            <p className={"text-5xl font-semibold text-light"}>{hour}</p>
          </div>
          <div className={"space-y-0.5 text-center"}>
            <h5 className={"text-light text-lg"}>Duration</h5>
            <p className={"text-5xl font-semibold text-light"}>
              30&nbsp;minutes
            </p>
          </div>
        </div>
      </div>
      <div className="mt-6 mx-auto flex max-w-2xl gap-x-5 w-full">
        <Button
          disabled={isLoading}
          className="w-full !text-light !h-[59px] !rounded-[11px]"
          onClick={() => {
            navigate(routes.exercises);
          }}
        >
          EXIT
        </Button>
        <Button
          disabled={isLoading}
          isLoading={isLoading}
          type="submit"
          className="!h-[59px] !rounded-[11px] !text-[20px] font-semibold w-full"
          onClick={handleConfirm}
        >
          &nbsp;CONFIRM
        </Button>
      </div>
    </div>
  );
}

export default MobileConfirmLiveCorrection;
